import { useEffect, useRef } from 'react';
import './HorizontalTicker.css';

function HorizontalTicker() {
  const scrollRef = useRef(null);

  useEffect(() => {
  const container = scrollRef.current;
  if (!container) return;

  let animationFrame;
  let scroll = 0;
  const scrollSpeed = 0.5; // ゆっくりにしたいなら0.3など

  const contentWidth = container.scrollWidth / 2;

  const step = () => {
    scroll += scrollSpeed;

    // 1つ分スクロールしきったらリセットしてループ
    if (scroll >= contentWidth) {
      scroll = 0;
    }

    container.scrollLeft = scroll;
    animationFrame = requestAnimationFrame(step);
  };

  animationFrame = requestAnimationFrame(step);

  return () => cancelAnimationFrame(animationFrame);
}, []);


  const text = '自然言語処理・バイオ・ヘルスケア・画像処理・自動運転・音声処理・材料・自動運転・ロボットアーム・HR・介護・';

  return (
    <div className="marquee">
      <div className="marquee-content">
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span>
      </div>
    </div>
  );
}

export default HorizontalTicker;
